import React from 'react';
import { HelpPopover } from '@gravity-ui/components';
import { TrashBin } from '@gravity-ui/icons';
import { Button, Icon, Text } from '@gravity-ui/uikit';
import { isArrayItem, isArraySpec, isObjectSpec, withGenerateButton, } from '../../../../core';
import { ErrorWrapper, GenerateRandomValueButton } from '../../../components';
import { block } from '../../../utils';
import './Row.css';
const b = block('row');
const RowBase = ({ name, spec, input, meta, verboseDescription, children, }) => {
    const arrayItem = React.useMemo(() => isArrayItem(name), [name]);
    const generateButton = React.useMemo(() => withGenerateButton(spec), [spec]);
    return (React.createElement("div", { className: b() },
        React.createElement("div", { className: b('left') },
            React.createElement("div", { className: b('left-inner') },
                React.createElement(Text, { className: b('title', { required: spec.required }) }, spec.viewSpec.layoutTitle),
                !verboseDescription && spec.viewSpec.layoutDescription ? (React.createElement("span", { className: b('note') },
                    React.createElement(Text, { className: b('note-inner') },
                        React.createElement(HelpPopover, { htmlContent: spec.viewSpec.layoutDescription, placement: ['bottom', 'top'] })))) : null)),
        React.createElement("div", { className: b('right') },
            React.createElement("div", { className: b('right-inner') },
                React.createElement(ErrorWrapper, { name: name, meta: meta, withoutChildErrorStyles: 
                    // TODO: remove condition spec.viewSpec.type !== 'select'
                    (isArraySpec(spec) && spec.viewSpec.type !== 'select') ||
                        isObjectSpec(spec), className: b('error-wrapper') }, children),
                generateButton ? (React.createElement(GenerateRandomValueButton, { spec: spec, onChange: input.onChange })) : null,
                arrayItem ? (React.createElement(Button, { view: "flat-secondary", className: b('remove-button'), onClick: input.onDrop, qa: `${name}-remove-item` },
                    React.createElement(Icon, { data: TrashBin, size: 16 }))) : null),
            verboseDescription && spec.viewSpec.layoutDescription ? (React.createElement("div", { className: b('description'), dangerouslySetInnerHTML: { __html: spec.viewSpec.layoutDescription } })) : null)));
};
export const Row = (props) => React.createElement(RowBase, Object.assign({}, props));
export const RowVerbose = (props) => React.createElement(RowBase, Object.assign({ verboseDescription: true }, props));
